export const tr = {
    'validation-empty-name': 'Video adı belirtilmemiş',
    'validation-empty-text': 'Değer boş bırakılamaz'
};
